import { ref as f, onMounted as w, onUnmounted as g } from "vue";
import { isScreenSmall as c } from "../utils/utilsScreen.js";
const S = (n) => {
  const r = f(12), a = () => {
    const o = document.querySelectorAll(".wds-page--snap-right"), d = document.querySelectorAll(".wds-page--snap-left");
    o.length > 0 && o.forEach((t) => {
      const e = t.querySelector(".wds-grid"), l = e.offsetWidth, s = e.querySelector(".wds-grid__col:last-child >*:last-child");
      c(n.value) ? s.style.width = "unset" : s.style.width = `calc(100% + (100vw - ${l}px) / 2 + ${r.value}px)`;
    }), d.length > 0 && d.forEach((t) => {
      const e = t.querySelector(".wds-grid"), l = e.offsetWidth, s = e.querySelector(".wds-grid__col:first-child"), i = e.querySelector(".wds-grid__col:first-child >*:last-child");
      c(n.value) ? (s.style.direction = "unset", i.style.width = "unset") : (s.style.direction = "rtl", i.style.width = `calc(100% + (100vw - ${l}px) / 2 + ${r.value}px)`);
    });
  }, u = () => {
    const o = document.querySelectorAll(".wds-container--snap-right"), d = document.querySelectorAll(".wds-container--snap-left");
    o.length > 0 && o.forEach((t) => {
      const e = t.offsetWidth, l = t.querySelector(".wds-grid").offsetWidth, s = (e - l) / 2, i = t.querySelector(".wds-grid > .wds-grid__col:last-child >*:last-child");
      i && (c(n.value) ? i.style.width = "unset" : i.style.width = `calc(100% + ${s}px + ${r.value}px)`);
    }), d.length > 0 && d.forEach((t) => {
      const e = t.offsetWidth, l = t.querySelector(".wds-grid").offsetWidth, s = (e - l) / 2, i = t.querySelector(".wds-grid > .wds-grid__col:first-child"), h = t.querySelector(".wds-grid > .wds-grid__col:first-child >*:last-child");
      !i || !h || (c(n.value) ? (i.style.direction = "unset", h.style.width = "unset") : (i.style.direction = "rtl", h.style.width = `calc(100% + ${s}px + ${r.value}px)`));
    });
  };
  return w(() => {
    setTimeout(() => {
      u(), a();
    }, 0), window.addEventListener("resize", u), window.addEventListener("resize", a);
  }), g(() => {
    window.removeEventListener("resize", u), window.removeEventListener("resize", a);
  }), {
    gutterSpacing: r
  };
};
export {
  S as useGrid
};
